
import RequestAbstract from "../abstract";

export default class FiltersIpList extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/filters-ip-list";
    }
}

